class EfFiliaisSelector {
    constructor(gql, $filter, $scope) {
        this.gql = gql
        this.$filter = $filter
        this.empresasSelecionadas = []

        this.apply = (fun) => $scope.$apply(fun)

        $scope.$watchCollection(() => this.empresasSelecionadas, () => {
            this.setViewValue()
        })
    }

    get cacheKey() {
        return this.cacheAs && `ef-filiais-selector-${this.cacheAs}-${this.contratoId}`
    }

    $onInit() {
        this.ngModelCtrl.$setValidity('required', false)

        this.promise = this
            .loadEmpresas()
            .then(empresas => {
                this.empresas = empresas

                const filiaisInCache = this
                    .maybeReadFiliaisIdsFromCache()
                    .filter(filialIdInCache => empresas.some(filial => filial.id === filialIdInCache))

                if (filiaisInCache.length) {
                    this.empresasSelecionadas = filiaisInCache
                }

                if (this.empresas.length == 1) {
                    this.empresaSelecionada = this.empresas[0]
                    this.empresasSelecionadas = [this.empresas[0].id]
                }
            })
            .finally(() => this.apply())

        this.ngModelCtrl.$render = () => {
            this.empresasSelecionadas = this.ngModelCtrl.$viewValue
        }
    }

    setViewValue() {
        const isValid = this.empresasSelecionadas && this.empresasSelecionadas.length > 0
        this.ngModelCtrl.$setValidity('required', isValid)

        if (this.ngModelCtrl.$valid) {
            if (this.cacheKey) localStorage.setItem(this.cacheKey, JSON.stringify(this.empresasSelecionadas))
            this.ngModelCtrl.$setViewValue(this.empresasSelecionadas)
        } else {
            this.ngModelCtrl.$setViewValue(null)
        }
    }

    loadEmpresas() {
        const query = gql`
            query Empresas($empresaId: Int!) {
                usuarioAtual {
                    id
                    permissoes(filter: {empresaId: $empresaId}) {
                        id
                        empresas: filiais {
                            id
                            cnpj
                            razaoSocial
                            ferramentasDisponiveis
                            cidade {
                                id
                                nome
                                estado {
                                    id
                                    sigla
                                }
                            }
                        }
                    }
                }
            }
        `

        return this.gql
            .query(query, { empresaId: parseInt(this.contratoId) })
            .then(({ usuarioAtual: { permissoes: [{ empresas }] } }) => {
                return empresas
                    .filter(empresa => !this.ferramenta || empresa.ferramentasDisponiveis.includes(this.ferramenta))
                    .map(empresa => ({
                        ...empresa,
                        id: empresa.id,
                        cidade: empresa.cidade.nome,
                        estado: empresa.cidade.estado.sigla
                    }))
            })
    }

    checkAll() {
        this.empresasSelecionadas = this.empresas.map(empresa => empresa.id)
    }

    highlight(search, empresa) {
        const cnpj = this.$filter('cpfCnpj')(empresa.cnpj)
        const text = `${cnpj} (${empresa.cidade}/${empresa.estado})`

        return search.split(' ').reduce(this.$filter('highlight'), text)
    }

    maybeReadFiliaisIdsFromCache() {
        try {
            if (this.cacheKey) {
                return JSON.parse(localStorage.getItem(this.cacheKey)) || []
            }
        } catch (_) { }

        return []
    }
}

angular.module('eficienciaFiscalModule')
    .component('efFiliaisSelector', {
        controller: ['gql', '$filter', '$scope', EfFiliaisSelector],
        bindings: {
            onChange: '&',
            contratoId: '<',
            ferramenta: '@',
            cacheAs: '@'
        },
        require: {
            ngModelCtrl: 'ngModel'
        },
        template: `
            <div ng-if="$ctrl.empresas.length == 1">
                <label>Filial</label>
                <ui-select 
                    theme="bootstrap"
                    name="empresa"
                    ng-model="$ctrl.empresaSelecionada"
                    ng-change="$ctrl.setViewValue()"
                    ng-disabled="true"
                    style="width:100%"
                    required="true">
                    <ui-select-match placeholder="Selecionar uma filial">
                        {{$select.selected.cnpj | cpfCnpj}} ({{$select.selected.cidade}}/{{$select.selected.estado}})
                    </ui-select-match>
                    <ui-select-choices repeat="empresa in ($ctrl.empresas | filter: $select.search) track by empresa.id">
                        <div ng-bind-html="$ctrl.highlight($select.search, empresa)"></div>
                    </ui-select-choices>
                </ui-select>
            </div>

            <div ng-if="$ctrl.empresas.length > 1">
                <label>
                    Filiais
                    (<a href="javascript:void(0)" ng-click="$ctrl.checkAll()">selecionar todas</a>)
                    <i class="fa fa-trash-o text-danger cursor-pointer" 
                        ng-click="$ctrl.empresasSelecionadas = []"
                        ng-if="$ctrl.empresasSelecionadas.length > 0"></i>
                </label>
                <ui-select
                    multiple theme="bootstrap" name="empresa"
                    ng-model="$ctrl.empresasSelecionadas" 
                    reset-search-input="false"
                    close-on-select="false"
                    style="width:100%"
                    required="true">
                    <ui-select-match placeholder="Selecionar filiais...">
                        {{($item.cnpj | cpfCnpj).slice(11)}} ({{$item.cidade}}/{{$item.estado}})
                    </ui-select-match>
                    <ui-select-choices repeat="empresa.id as empresa in $ctrl.empresas | filter: $select.search">
                        <div ng-bind-html="$ctrl.highlight($select.search, empresa)"></div>
                    </ui-select-choices>
                </ui-select>
            </div>
        `
    })
